export const provincesArray = [
  { value: 'AB', label: 'AB', name: 'Alberta' },
  { value: 'BC', label: 'BC', name: 'British Columbia' },
  { value: 'MB', label: 'MB', name: 'Manitoba' },
  { value: 'NB', label: 'NB', name: 'New Brunswick' },
  { value: 'NL', label: 'NL', name: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'NS', name: 'Nova Scotia' },
  { value: 'ON', label: 'ON', name: 'Ontario' },
  { value: 'PE', label: 'PE', name: 'Prince Edward Island' },
  { value: 'QC', label: 'QC', name: 'Quebec' },
  { value: 'SK', label: 'SK', name: 'Saskatchewan' },
];
